import { create } from 'zustand';
import { Usuario } from '../types';

interface AuthState {
  user: Usuario | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

interface AuthActions {
  setUser: (user: Usuario) => void;
  setToken: (token: string) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
}

type AuthStore = AuthState & AuthActions;

const USER_KEY = 'user';

// El usuario se guarda junto al token: sin señal, /auth/me no responde y el QR
// igual necesita saber quién está registrando.
const leerUsuarioGuardado = (): Usuario | null => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? (JSON.parse(raw) as Usuario) : null;
  } catch {
    return null;
  }
};

export const useAuthStore = create<AuthStore>((set) => ({
  user: localStorage.getItem('token') ? leerUsuarioGuardado() : null,
  token: localStorage.getItem('token'),
  isAuthenticated: !!localStorage.getItem('token'),
  isLoading: false,

  setUser: (user) => {
    try { localStorage.setItem(USER_KEY, JSON.stringify(user)); } catch {}
    set({ user, isAuthenticated: true });
  },
  
  setToken: (token) => {
    localStorage.setItem('token', token);
    set({ token, isAuthenticated: true });
  },
  
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem(USER_KEY);
    set({ user: null, token: null, isAuthenticated: false, isLoading: false });
  },
  
  setLoading: (isLoading) => set({ isLoading }),
})); 